<template>
    <BaseIcon
        :size="sizeIcon"
        class="animate-spin"
        icon="spinner"
    ></BaseIcon>
</template>

<script>
import BaseIcon from './Base/BaseIcon'

export default {
  name: 'MyLoader',
  components: { BaseIcon },
  props: {
    sizeIcon: String
  }
}
</script>

<style scoped>

</style>
